(function () {
  if (window.__coveraxMotionInit) return;
  window.__coveraxMotionInit = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    const items = document.querySelectorAll('[data-cx-reveal]');
    if (!items.length) return;

    if (reducedMotion) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    items.forEach((el) => {
      if (el.classList.contains('is-visible')) return;
      observer.observe(el);
    });
  }

  function initTimeline(root) {
    const timeline = root.querySelector('[data-cx-timeline]');
    if (!timeline) return;

    const items = timeline.querySelectorAll('[data-cx-timeline-item]');
    if (!items.length) return;

    const update = () => {
      const triggerY = window.innerHeight * 0.58;
      let activeCount = 0;

      items.forEach((item, index) => {
        const dot = item.querySelector('[data-cx-timeline-dot]');
        const rect = dot ? dot.getBoundingClientRect() : item.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const isActive = center <= triggerY;
        item.classList.toggle('is-active', isActive);
        if (isActive) activeCount = index + 1;
      });

      const progress = items.length <= 1 ? 1 : Math.max(0, Math.min(1, (activeCount - 0.35) / (items.length - 1)));
      timeline.style.setProperty('--cx-timeline-progress', progress);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  function initTimelines() {
    document.querySelectorAll('[data-cx-timeline-root]').forEach(initTimeline);
  }

  function init() {
    initReveal();
    initTimelines();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
